//external link
import React from 'react';
import PropTypes from 'prop-types';


const ExternalLink = ((props) => {
     
    return (
       
            <svg style={{ cursor: 'pointer' }} width="12" height="11" viewBox="0 0 12 11" position="absolute"  fill="none" xmlns="http://www.w3.org/2000/svg">
                 <path fill-rule="evenodd" clip-rule="evenodd" d="M4.0732 7.45538C3.97557 7.55303 3.97557 7.71132 4.0732 7.80895L4.19105 7.9268C4.2887 8.02443 4.44699 8.02443 4.54462 7.9268L11.2769 1.19448L11.2917 1.20921L11.2845 3.08334C11.2845 3.22141 11.3965 3.33335 11.5345 3.33335H11.7429C11.8809 3.33335 11.9929 3.22141 11.9929 3.08334L12 0.250001C12 0.111917 11.8881 0 11.75 0L8.91666 0.00714586C8.77857 0.00714586 8.66665 0.119063 8.66665 0.257147V0.46546C8.66665 0.603523 8.77859 0.715461 8.91666 0.715461L10.7908 0.708336L10.8055 0.723065L4.0732 7.45538ZM8.73993 4.73326L8.9066 4.56659C9.06408 4.40911 9.33337 4.52065 9.33337 4.74338V9.66671C9.33337 10.219 8.88566 10.6667 8.33337 10.6667H1C0.44771 10.6667 0 10.219 0 9.66671V2.33335C0 1.78106 0.44771 1.33335 1 1.33335H8.24953C8.47226 1.33335 8.5838 1.60262 8.4263 1.76012L8.25964 1.92679C8.21276 1.97368 8.14918 2.00002 8.08287 2.00002H1C0.81592 2.00002 0.666669 2.14925 0.666669 2.33335V9.66671C0.666669 9.85082 0.81592 10 1 10H8.33337C8.51745 10 8.6667 9.85082 8.6667 9.66671V4.91003C8.6667 4.84373 8.69305 4.78014 8.73993 4.73326Z"
                  fill="currentColor"/>
              </svg>
              
            )
})

ExternalLink.props = {
    onClick: PropTypes.func,
}

ExternalLink.defaultProps = {
    onClick: (props) => {
        
     },
}

export default ExternalLink;